import type IMapProperty from '../private/IMapProperty';
import { VALUES_FIELD_NAME } from './BackgroundModeDto.private';

const MAPPINGS: IMapProperty[] = [
    {
        localName: 'id',

        defaultValue: 0,
    },
    {
        localName: 'name',

        defaultValue: VALUES_FIELD_NAME[0],
    },
];

export default MAPPINGS;
